/* global u */
import { setDropdownValue, getDropdownValue } from '../../../01-atoms/05-forms/dropdown/dropdown';
import Datepicker from '../../../01-atoms/05-forms/datepicker/datepicker';


/**
 * Initialises date dropdown with flatpickr calendar
 */
export default function (context) {
  if (typeof context === 'undefined') {
    context = document;
  }
  const dropdown_sections = [...context.getElementsByClassName('js-date-dropdown')];

  dropdown_sections.forEach(section => {
    const date_granularity = section.hasAttribute('data-date-granularity') ? section.getAttribute('data-date-granularity') : 'day';
    const dropdown_areas = [...section.querySelectorAll('select.js-dropdown__input')];
    // Create dropdowns - assuming the dropdown_areas are in asc order (day/month/year), and dependent on date granularity.
    const dd_day = date_granularity !== 'month' && date_granularity !== 'year' ? dropdown_areas.shift() : null;
    const dd_month = date_granularity !== 'year' ? dropdown_areas.shift() : null;
    const dd_year = dropdown_areas.shift();
    const datepicker_elem = section.getElementsByClassName('js-datepicker')[0];
    if (!datepicker_elem) {
      return;
    }

    const id = datepicker_elem.getAttribute('id');
    const $btn = u(`#${id}-bn_date`);
    const dp1 = new Datepicker(id, $btn, true);

    if (!dp1.init) {
      return;
    }


    dp1.onDatePicked(({ day, month, year }) => {
      setDropdownValue(dd_day, day);
      setDropdownValue(dd_month, month);
      setDropdownValue(dd_year, year);
    });

    /**
     * Sync dropdown changes to the datepicker value.
     */
    function setDatepickerValue() {
      // Get date dropdown values, or default to 1 if dropdown is not present (date granularity).
      let day = dd_day ? parseInt(getDropdownValue(dd_day)) : null,
        month = dd_month ? parseInt(getDropdownValue(dd_month)) : null,
        year = dd_year ? parseInt(getDropdownValue(dd_year)) : null;

      if (!day && !month && !year) {

        // Else if all are empty, empty the datepicker date.
        dp1.unsetDate();
      } else {

        // Set default values for null variables.
        day = day === null ? 1 : day;
        month = month === null ? 1 : month;
        year = year === null ? 1 : year;

        // If all parts are set, update datepicker (no pun intended).
        if (day && month && year) {
          // Set datepicker date.
          // Month here is 0-based.
          dp1.setDate(day, month - 1, year, true);
        }
      }
    }

    if (dd_day) {
      dd_day.addEventListener('change', e => {
        setDatepickerValue();
      });
    }

    if (dd_month) {
      dd_month.addEventListener('change', e => {
        setDatepickerValue();
      });
    }

    if (dd_year) {
      dd_year.addEventListener('change', e => {
        setDatepickerValue();
      });
    }

    // Remove the js class to prevent double-init e.g. by Drupal.
    section.classList.remove('js-date-dropdown');
  });
}